import request from '@/utils/request'
let baseURL = '/im-api';

//找出用户的所有好友
// export function getAllFriend(data) {
//   return request({
//     url: '/Friend/v1/findAllFriend',
//     method: 'post',
//     baseURL,
//     data
//   })
// }

/*
{
accid (string): 云信帐号，即用户的openid
}
*/

// 获取最新的推拉流地址
export function videoChatAddress(data) {
  return request({
    url: '/VideoChannel/v1/address',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
cid (string): 频道ID，32位字符串
}
*/

// 查询聊天室信息
export function getChatroomInfo(data) {
  return request({
    url: '/ChatRoom/v1/getChatroomInfo',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
needOnlineUserCount (boolean, optional): 是否需要返回在线人数，true或false，默认false ,
roomid (integer): 聊天室id
}
*/

// 查询聊天室信息
export function getAccidToken(data) {
  return request({
    url: '/UserYunxin/v1/getAccidToken',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
userOpenId (string): 用户OpenId
}
*/

// 获取录制文件列表 根据频道ID获取全部录制视频文件（分页）
export function getVideoFiles(data) {
  return request({
    url: '/VideoFile/v1/getVideoFiles',
    method: 'post',
    baseURL,
    data
  })
}
/*
 {
cid (string): 频道ID，32位字符串 ,
page (integer, optional),
size (integer, optional),
stat (boolean, optional): 状态，0 封禁，1 正常
}
* */

// ----------- 2020.06.24 ------------------------
// 直播录像列表--分页
export function getVideoFilesList(params) {
  return request({
    url: '/VideoFile/v1/getVideoFiles',
    method: 'get',
    baseURL,
    params
  })
}

// 根据视频文件ID获取文件信息
export function getVideoFileByVid(params) {
  return request({
    url: '/VideoFile/v1/getVideoFileByVid',
    method: 'get',
    baseURL,
    params
  })
}

// 查询互动直播列表--分页
export function getRoomsByPage(params) {
  return request({
    url: '/ChatRoom/v1/getRoomsByPage',
    method: 'get',
    baseURL,
    params
  })
}
